var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "minus_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#minus_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M6 12.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 5.25 12c0-.213.072-.391.216-.535A.726.726 0 0 1 6 11.25h12c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H6Z",
    fill: "currentColor"
  }))));
};
export default SvgMinus;